import { GraphSummary } from '../../../@biz_investor/opportunity-detail/GraphSummary'

export const ChartTooltip = ({ active, payload, label: months }: any) => {
  if (!active || !payload || !payload.length) return null

  const earlyWithdraw = payload.find(
    (item: any) => item.dataKey === 'earlyWithdrawVal'
  )
  const bonaship = payload.find((item: any) => item.dataKey === 'bonVal')
  const inflation = payload.find((item: any) => item.dataKey === 'infVal')
  const bankSavings = payload.find((item: any) => item.dataKey === 'bankVal')
  const cash = payload.find((item: any) => item.dataKey === 'casVal')

  const selectedPayload = payload[0].payload
  const slug = selectedPayload.slug

  const rate = selectedPayload.bonVal
    ? selectedPayload.rates.bonaship
    : selectedPayload.rates.earlyWithdraw

  // console.log('-----')
  // console.log(earlyWithdraw)
  // console.log(bonaship)
  // console.log(inflation)
  // console.log(bankSavings)
  // console.log(cash)
  // console.log(slug)

  return (
    <GraphSummary
      className="z-20"
      earlyWithdraw={earlyWithdraw?.value}
      bonaship={bonaship?.value}
      inflation={inflation?.value}
      bankSavings={bankSavings?.value}
      cash={cash?.value}
      months={months}
      intPerAnn={rate}
      slug={slug}
    />
  )
}
